// import hasSampledVariantSelector from 'modules/variant/redux/selectors/has-sampled'

import openModalAction from 'modules/modal/redux/actions/open'
import { MODAL_ID } from 'modules/modal/redux/constants'
import hasReachedMaxFreeSamplesCountCartSelect from 'modules/cart/redux/selectors/has-reached-max-free-samples-count'
import getUnlockedExtraFreeSamplesTierCartSelect from 'modules/cart/redux/selectors/get-unlocked-extra-free-samples-tier'
import { UNLOCKED_EXTRA_FREE_SAMPLES_COUNT_TIER } from 'modules/cart/constants'

/**
 * @param previousState
 * @returns {(function(*, *): Promise<undefined|{wasRemoved: *, wasAdded}>)|*}
 */
export default function afterAddCartAction ({ previousState }) {
  return (dispatch, getState) => {
    const beforeUnlockedExtraFreeSamplesTier = getUnlockedExtraFreeSamplesTierCartSelect(previousState)
    const beforeHasReachedMaxFreeSamplesCount = hasReachedMaxFreeSamplesCountCartSelect(previousState)
    const afterUnlockedExtraFreeSamplesTier = getUnlockedExtraFreeSamplesTierCartSelect(getState())
    if (
      afterUnlockedExtraFreeSamplesTier !== UNLOCKED_EXTRA_FREE_SAMPLES_COUNT_TIER.ABOVE_0 &&
      beforeUnlockedExtraFreeSamplesTier !== afterUnlockedExtraFreeSamplesTier &&
      beforeHasReachedMaxFreeSamplesCount
    ) {
      dispatch(openModalAction(MODAL_ID.UNLOCKED_EXTRA_FREE_SAMPLES))
    }
  }
}
